<template>
  <div id="step-progress" class="step-progress">
    <div v-if="showStages === 'QC_FAILED' || showStages === 'BOTH'" class="step-progress__wrapper">
      <div
        class="step-progress__wrapper-before"
        :style="{'background-color': passiveColor, height: lineThickness + 'px'}"
      ></div>
      <div
        v-if="showStages === 'BOTH'"
        calss="step-progress__hide-old-bar-before"
        :style="{
          background: 'linear-gradient(90deg, white 50%, gray 50%)',
          height: lineThickness + 'px',
          content: '',
          'z-index': 2,
          position: 'absolute',
          left: 0,
          top: '50%',
          width: '100%',
          transform: 'translateY(-50%) perspective(1000px)'
        }"
      ></div>
      <div class="step-progress__bar">
        <div
          v-for="(step, index) in subSteps"
          :id="'sub-progress-' + index"
          :key="step.indentifier"
          class="step-progress__step"
          :style="{
            '--activeColor': activeColor,
            '--passiveColor': passiveColor,
            '--activeBorder': activeThickness + 'px',
            '--passiveBorder': passiveThickness + 'px',
            opacity: showStages === 'QC_FAILED' || (showStages === 'BOTH' && hideTill) <= index ? 1 : 0
          }"
          :class='{
        "step-progress__step--active": index === currentStep,
        "step-progress__step--valid": index &lt; currentStep
      }'
          @click="stepClicked(step)"
        >
          <span>{{ index + 1 }}</span>
          <div class="step-progress__step-icon" :class="iconClass"></div>
          <div class="step-progress__step-label">{{ step.name }}</div>
        </div>
      </div>
      <div
        class="step-progress__wrapper-after"
        :style="{
          transform: 'scaleX(' + subScaleX + ') translateY(-50%) perspective(1000px)',
          'background-color': activeColor,
          height: lineThickness + 'px'
        }"
      ></div>
    </div>
    <div v-if="showStages === 'QC_PASSED' || showStages === 'BOTH'" class="step-progress__wrapper">
      <div
        class="step-progress__wrapper-before"
        :style="{'background-color': passiveColor, height: lineThickness + 'px'}"
      ></div>
      <div class="step-progress__bar">
        <div
          v-for="(step, index) in steps"
          :id="'progress-' + index"
          :key="step.indentifier"
          class="step-progress__step"
          :style="{
            '--activeColor': activeColor,
            '--passiveColor': passiveColor,
            '--activeBorder': activeThickness + 'px',
            '--passiveBorder': passiveThickness + 'px'
          }"
          :class='{
        "step-progress__step--active": index === currentStep,
        "step-progress__step--valid": index &lt; currentStep
      }'
          @click="stepClicked(step)"
        >
          <span>{{ index + 1 }}</span>
          <div class="step-progress__step-icon" :class="iconClass"></div>
          <div class="step-progress__step-label">{{ step.name }}</div>
        </div>
      </div>
      <div
        class="step-progress__wrapper-after"
        :style="{
          transform: 'scaleX(' + scaleX + ') translateY(-50%) perspective(1000px)',
          'background-color': activeColor,
          height: lineThickness + 'px'
        }"
      ></div>
    </div>
  </div>
</template>

<script>
  const getOffset = (el) => {
    const rect = el.getBoundingClientRect()
    return {
      left: rect.left + window.pageXOffset,
      top: rect.top + window.pageYOffset,
      width: rect.width || el.offsetWidth,
      height: rect.height || el.offsetHeight
    }
  }

  const connect = (div1, div2, color, thickness) => {
    const off1 = getOffset(div1)
    const off2 = getOffset(div2)

    const x1 = off1.left + off1.width
    const y1 = off1.top + off1.height

    const x2 = off2.left + off2.width
    const y2 = off2.top

    const length = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1))

    const angle = Math.atan2(y1 - y2, x1 - x2) * (180 / Math.PI)

    const htmlLine = `<div id="cross-line" style='padding:0px; margin:0px; height:${thickness}px; background-color:${color};
        line-height:1px; position:absolute; left:19%; top:90px; width:${length}px;
         -moz-transform:rotate(${angle}deg); -webkit-transform:rotate(${angle}deg); -o-transform:rotate(${angle}deg); -ms-transform:rotate(${angle}deg); transform:rotate(${angle}deg);' />`
    const div = document.createElement("div")
    div.innerHTML = htmlLine
    document.getElementById("step-progress").append(div.firstChild)
  }
  export default {
    name: "StepProgress",
    props: {
      steps: {
        type: Array,
        default() {
          return []
        },
        validator(val) {
          return val && val.length > 0
        }
      },
      subSteps: {
        type: Array,
        default() {
          return []
        }
      },
      hideTill: {
        type: Number,
        default: 0
      },
      currentStep: {
        type: Number,
        default: 0
      },
      showStages: {
        type: String,
        default: "BOTH"
      },
      iconClass: {
        type: String,
        default: "fa fa-check"
      },
      activeColor: {
        type: String,
        default: "red"
      },
      passiveColor: {
        type: String,
        default: "gray"
      },
      activeThickness: {
        type: Number,
        default: 8
      },
      passiveThickness: {
        type: Number,
        default: 5
      },
      lineThickness: {
        type: Number,
        default: 8
      }
    },
    computed: {
      scaleX() {
        let step = this.currentStep
        if (step < 0) {
          step = 0
        } else if (step >= this.steps.length) {
          step = this.steps.length - 1
        }
        return step / (this.steps.length - 1)
      },
      subScaleX() {
        let step = this.currentStep
        if (step < 0) {
          step = 0
        } else if (step >= this.subSteps.length) {
          step = this.subSteps.length - 1
        }
        return step / (this.subSteps.length - 1)
      }
    },
    watch: {
      showStages(value) {
        this.$nextTick(() => {
          setTimeout(() => {
            const d1 = document.getElementById("sub-progress-2")
            const d2 = document.getElementById("progress-1")
            if (d1 && d2) {
              connect(d1, d2, "gray", 8)
            }
          }, 100)
        })
        if (value !== "BOTH") {
          const crossline = document.getElementById("cross-line")
          if (crossline) {
            crossline.classList.add("display-none")
          }
        } else {
          const crossline = document.getElementById("cross-line")
          if (crossline) {
            crossline.classList.remove("display-none")
          }
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        setTimeout(() => {
          const d1 = document.getElementById("sub-progress-2")
          const d2 = document.getElementById("progress-1")
          if (d1 && d2) {
            connect(d1, d2, "gray", 8)
          }
        }, 100)
      })
    },
    methods: {
      stepClicked(step) {
        this.$emit("step-change", {...step})
      }
    }
  }
</script>

<style lang="scss">
  .step-progress {
    position: relative;
  }
  .step-progress__wrapper {
    width: 90%;
    margin: 0 auto;
    position: relative;
  }

  .step-progress__wrapper-before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    height: 12px;
    width: 100%;
    background-color: gray;
    transform: translateY(-50%) perspective(1000px);
  }

  .step-progress__wrapper-after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    height: 12px;
    width: 100%;
    background-color: red;
    transform: scaleX(0) translateY(-50%) perspective(1000px);
    transform-origin: left center;
    transition: transform 0.5s ease;
  }

  .step-progress__bar {
    width: 100%;
    display: flex;
    height: 100px;
    justify-content: space-between;
    align-items: center;
  }

  .step-progress__step {
    z-index: 2;
    position: relative;
    --activeColor: red;
    --passiveColor: gray;
    --activeBorder: 5px;
    --passiveBorder: 5px;
  }
  .step-progress__step span {
    color: var(--passiveColor);
    transition: 0.3s ease;
    display: block;
    font-size: 14px;
    transform: translate3d(0, 0, 0) scale(1) perspective(1000px);
    font-weight: 900;
    text-align: center;
    opacity: 1;
  }
  .step-progress__step--active span {
    color: var(--activeColor);
  }
  .step-progress__step--active .step-progress__step-label {
    color: var(--activeColor);
  }
  .step-progress__step--active .step-progress__step-icon {
    opacity: 1;
  }
  .step-progress__step--valid .step-progress__step-icon {
    opacity: 1;
    transform: translate3d(-50%, -50%, 0) scale(1) perspective(1000px);
  }
  .step-progress__step--valid span {
    color: var(--activeColor);
    opacity: 0;
    transform: translate3d(0, 0, 0) scale(2) perspective(1000px);
  }
  .step-progress__step--valid .step-progress__step-label {
    color: var(--activeColor);
  }
  .step-progress__step:after {
    content: "";
    position: absolute;
    z-index: -1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) perspective(1000px);
    width: 40px;
    cursor: pointer;
    height: 40px;
    background-color: #fff;
    border-radius: 50%;
    border: var(--passiveBorder) solid var(--passiveColor);
    transition: 0.3s ease;
  }
  .step-progress__step--active:after {
    border: var(--activeBorder) solid var(--activeColor);
  }
  .step-progress__step--valid:after {
    background-color: var(--activeColor);
    border: var(--activeBorder) solid var(--activeColor);
  }

  .step-progress__step-label {
    position: absolute;
    top: calc(100% + 25px);
    left: 50%;
    transform: translateX(-50%) perspective(1000px);
    white-space: nowrap;
    font-size: 10px;
    font-weight: 600;
    color: gray;
    transition: 0.3s ease;
  }

  .step-progress__step-icon {
    font-size: 10px;
    color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transition: transform 0.3s ease;
    opacity: 0;
    transform: translate3d(-50%, -50%, 0) scale(0) perspective(1000px);
  }
  @media (max-width: 767px) {
    .step-progress__step-icon {
      font-size: 22px;
    }
  }
</style>
